import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { IconAdd } from '@contrast-security-inc/design-system-foundations'

interface AddJiraFieldLinkProps {
  addField: () => void
}
export const AddJiraFieldLink: FC<AddJiraFieldLinkProps> = ({ addField }) => {
  const intl = useIntl()

  return (
    <Link
      testId="add-jira-field-link"
      className={css`
        display: flex;
        align-items: center;
      `}
      onClick={addField}
    >
      <IconAdd size="sm" />
      <Text>
        {intl.formatMessage({ id: 'action_integrationsSettings_addJiraField' })}
      </Text>
    </Link>
  )
}
